import type { ProjectScope } from './project-scope';

const pendingCueAnchorWriteKeys = new Set<string>();
const pendingCueAnchorDeleteKeys = new Set<string>();
const pendingCustomCueWriteKeys = new Set<string>();

function promptBookEntityKey(scope: ProjectScope, id: string): string {
    return `${scope.orgId}/${scope.projectId}/${id}`;
}

function promptBookScopePrefix(scope: ProjectScope): string {
    return `${scope.orgId}/${scope.projectId}/`;
}

function idFromPromptBookKey(scope: ProjectScope, key: string): string | null {
    const prefix = promptBookScopePrefix(scope);
    return key.startsWith(prefix) ? key.slice(prefix.length) : null;
}

export function markPendingCueAnchorWrite(scope: ProjectScope, id: string): void {
    pendingCueAnchorWriteKeys.add(promptBookEntityKey(scope, id));
    pendingCueAnchorDeleteKeys.delete(promptBookEntityKey(scope, id));
}

export function clearPendingCueAnchorWrite(scope: ProjectScope, id: string): void {
    pendingCueAnchorWriteKeys.delete(promptBookEntityKey(scope, id));
}

export function isPendingCueAnchorWrite(scope: ProjectScope, id: string): boolean {
    return pendingCueAnchorWriteKeys.has(promptBookEntityKey(scope, id));
}

export function markPendingCueAnchorDelete(scope: ProjectScope, id: string): void {
    pendingCueAnchorDeleteKeys.add(promptBookEntityKey(scope, id));
    pendingCueAnchorWriteKeys.delete(promptBookEntityKey(scope, id));
}

export function isPendingCueAnchorDelete(scope: ProjectScope, id: string): boolean {
    return pendingCueAnchorDeleteKeys.has(promptBookEntityKey(scope, id));
}

export function clearPendingCueAnchorDeletesMissingFromRemote(
    scope: ProjectScope,
    remoteAnchorIds: ReadonlySet<string>
): void {
    for (const key of Array.from(pendingCueAnchorDeleteKeys)) {
        const id = idFromPromptBookKey(scope, key);
        if (id && !remoteAnchorIds.has(id)) {
            pendingCueAnchorDeleteKeys.delete(key);
        }
    }
}

export function markPendingCustomCueWrite(scope: ProjectScope, id: string): void {
    pendingCustomCueWriteKeys.add(promptBookEntityKey(scope, id));
}

export function clearPendingCustomCueWrite(scope: ProjectScope, id: string): void {
    pendingCustomCueWriteKeys.delete(promptBookEntityKey(scope, id));
}

export function isPendingCustomCueWrite(scope: ProjectScope, id: string): boolean {
    return pendingCustomCueWriteKeys.has(promptBookEntityKey(scope, id));
}

export function clearPendingPromptBookWrites(): void {
    pendingCueAnchorWriteKeys.clear();
    pendingCueAnchorDeleteKeys.clear();
    pendingCustomCueWriteKeys.clear();
}
